<template>
  <div class="text-left" v-if="event && !executing">
    <div class="mb-4">
      <div>
        <mdb-input type="checkbox" id="forceWaitlist" name="forceWaitlist" v-model="event.forceWaitlist" label="Put new reservations on the waitlist"/>
      </div>
      <div>
        <mdb-input type="checkbox" id="closeReservations" name="closeReservations" v-model="event.closeReservations" label="Close event to new reservations"/>
      </div>
      <div>
        <mdb-input type="checkbox" id="changeAfterClose" name="changeAfterClose" v-model="event.changeAfterClose" label="Allow changes to reservations if event is closed to new reservations."/>
      </div>
      <div>
        <mdb-input type="checkbox" id="allowJoinInProgress" name="allowJoinInProgress" v-model="event.allowJoinInProgress" label="Allow new reservations after event has started."/>
      </div>
      <div>
        <mdb-input type="checkbox" id="hostNotParticipant" name="hostNotParticipant" v-model="event.hostNotParticipant" :label="'Don\'t treat ' + $tc('common.label.host',1) + ' as ' + $tc('common.label.attendee',1)"/>
      </div>
      <div>
        <mdb-input type="checkbox" id="notifyInitialNo" name="notifyInitialNo" v-model="event.notifyInitialNo" label="Notify on initial 'No' Response"/>
      </div>

    </div>
    <div class="mb-4">
      <label>If there's a waitlist, what should happen when a spot opens up?</label>
      <mdb-input id="wl1" :label="capitalize($tc('common.label.host',1)) + ' will handle manually'" name="wl1" radioValue="Manual" type="radio"
                 v-model="event.waitlistRule"/>
      <mdb-input id="wl2" :label="'Give to waiting ' + $tc('common.label.member',1) + ' who made the ' + capitalize($t('page.event.rsvp')) + ' first'" name="wl2" radioValue="By RSVP Date" type="radio"
                 v-model="event.waitlistRule"/>
      <mdb-input id="wl3" :label="'Give to waiting ' + $tc('common.label.member',1) + ' with most seniority'" name="wl2" radioValue="By Seniority" type="radio"
                 v-model="event.waitlistRule"/>
      <mdb-input id="wl4" :label="'Give to waiting ' + $tc('common.label.member',1) + ' with highest ' + event.reputationLabel + ' score'"  name="wl2" radioValue="By Reputation" type="radio"
                 v-if="event.reputationEnabled"
                 v-model="event.waitlistRule"/>
    </div>

    <div class="mb-4">
      <label>If there's no {{ $tc('common.label.host',1) }}, who can make themself {{hostWithArticle}}?</label>
      <mdb-input id="uh1" :label="'Only Admins/' + capitalize($tc('common.label.group',1)) + ' Organizers'" name="uh1" radioValue="0" type="radio"
                 v-model="event.unhostedRule"/>
      <mdb-input id="uh2" :label="'Admins/' + capitalize($tc('common.label.group',1)) + ' Orgs/' + capitalize($tc('common.label.event',1)) + ' Orgs'" name="uh2" radioValue="1" type="radio"
                 v-model="event.unhostedRule"/>
      <mdb-input id="uh3" label="Any Member" name="uh3" radioValue="2" type="radio"
                 v-model="event.unhostedRule"/>
    </div>


    <mdb-btn icon="save" color="success" @click="doSave">Save</mdb-btn>
    <mdb-btn icon="times-circle" color="danger" @click="doCancel">Cancel</mdb-btn>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </div>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbIcon, mdbInput} from 'mdbvue';
import SeriesModal from "./SeriesModal";
import articles from "articles";

export default {
    name: 'Event-Settings-Editor',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      SeriesModal
    },
    props: {
      id: {
        type: Number,
        default: null
      }
    },
    computed: {
      userDetails() {
        return this.$store.state.userDetails
      },
      group() {
        return this.$store.state.currentGroup
      },
      settings() {
        return this.$store.state.settings
      },
      executing() {
        return this.$store.state.executing
      },
      hostWithArticle() {
        return articles.articlize(this.$tc("common.label.host",1))
      }
    },
    data() {
      return {
        event: null,
        showSeriesModal: false,
        seriesChoice: null
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true);
      api.get("/event/otherSettings/" + this.id).then(
        (results) => {
          this.event = results.data;
        },
        (error) => {
          this.$notify.error({message: "Could not load rules. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      doCancel() {
        this.$emit("cancel")
      },
      setSeriesChoice(choice) {
        this.event.series = choice
        this.doSave()
      },
      doSave() {
        if (this.event.repeats && !this.event.series && this.event.status != "Draft") {
          this.showSeriesModal = true
          return
        }

        this.$store.dispatch("setExecuting", true);
        api.post('/event/otherSettings/' + this.id, this.event).then(
          (results) => {
            this.$emit("save")
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
          this.showSeriesModal = false
          this.seriesChoice = null
        })
      }
    }
  }
  ;
</script>
